// extracted by mini-css-extract-plugin
module.exports = {"radio":"CheckboxWithText_radio__I_mFS","checkBoxTitle":"CheckboxWithText_checkBoxTitle__FgpBz","large":"CheckboxWithText_large__9FFDm"};